import { useEffect, useRef, useState } from "react";

export type LoaderState<T> =
  | {
      type: "loading";
    }
  | {
      type: "error";
      error: Error;
    }
  | {
      type: "success";
      data: T;
    };

export default function useLoader<T>(
  fetchData: () => Promise<T>,
): LoaderState<T> {
  const [state, setState] = useState<LoaderState<T>>({ type: "loading" });
  const fetchDataRef = useRef(fetchData);

  useEffect(() => {
    void (async () => {
      try {
        const result = await fetchData();
        setState({
          type: "success",
          data: result,
        });
      } catch (err) {
        setState({
          type: "error",
          error: err as Error,
        });
      }
    })();
    // Don't refetch if fetchData changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // We were getting false alarms about fetchData changing, even though they're
    // the same function (by reference).
    if (fetchDataRef.current !== fetchData) {
      console.error("fetchData should never change");
    }
    fetchDataRef.current = fetchData;
  }, [fetchData]);

  return state;
}
